import React from 'react';
import { getLoggedUser } from '../../../../state/user';
import i18n from '../../../../i18n';
import { getOrganizationList } from '../../../../models/organization';
import { SideBar } from '../../sidebar';
import FilterSection from '../../../common/Filter';
import Dropdown from '../../../common/DropDown';
import NoData from '../../../common/NoData';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import { getDeliveryGroups } from './services/auctionApprovalServices';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import DataTable from 'react-data-table-component';
import { apiUrl } from '../../../../constants/global';
import { NavLink } from 'react-router-dom';
import { AuctionAddFundModal } from './components/AuctionAddFundModal';
import { ClientAmountCard } from '../../../common/ClientAmountCard';
import HeaderBanner from '../../../common/HeaderBanner';
import { Download, FileSpreadsheet, Printer } from 'lucide-react';
import NewDropdown from '../../../common/NewDropDown';
import { downloadFile } from '../../../../utils/downloadFile';
import { DeliveryStatus } from '../../../../constants/status';

const user = getLoggedUser();
const roleAllowedStatuses = {
  PM: ['pending', 'approved', 'fundAdded', 'financeSettled', 'all'],
  F: ['approved', 'fundAdded', 'fundDeduct', 'financeSettled', 'all'],
  C: ['pending', 'approved', 'all'],
};
const allStatuses = [
  { type: 'pending', title: i18n.t('Pending'), amount: 0, auctionCount: 0 },
  { type: 'approved', title: i18n.t('approved'), amount: 0, auctionCount: 0 },
  { type: 'fundAdded', title: i18n.t('fundAdded'), amount: 0, auctionCount: 0 },
  { type: 'fundDeduct', title: i18n.t('fund_deduct'), amount: 0, auctionCount: 0 },
  { type: 'financeSettled', title: i18n.t('completed'), amount: 0, auctionCount: 0 },
  { type: 'all', title: i18n.t('all'), amount: 0, auctionCount: 0 },
];
const allowedStatuses = user ? roleAllowedStatuses[user.role] || [] : [];
const filteredMeta = allStatuses.filter((card) => allowedStatuses.includes(card.type));

export class AuctionApprovalList extends React.Component {
  constructor() {
    super();
    this.state = {
      search: {
        client: '',
        startDate: null,
        endDate: null,
      },
      input: {},
      clients: [],
      deliveryGroups: [],
      status: filteredMeta[0]?.type || 'approved', // default to first allowed
      activeTab: filteredMeta[0]?.type || 'approved',
      cardMeta: filteredMeta,
      isLoading: false,
      showAddFund: false,
      limit: 15,
      page: 1,
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    // Parse URL query params
    const params = new URLSearchParams(window.location.search);
    const search = {
      client: params.get('client') || '',
      startDate: params.get('startDate') || null,
      endDate: params.get('endDate') || null,
    };
    const status = params.get('status') || 'approved';
    const page = parseInt(params.get('page')) || 1;
    const limit = parseInt(params.get('limit')) || 15;

    this.setState({ search, status, page, limit, activeTab: status }, () => {
      this.getAllOrganization?.();
      this.getDeliveryGroups();
    });
  }

  // Update URL without refreshing page
  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
  }
  async getDeliveryGroups() {
    this.setState({ isLoading: true });
    let { limit, page, status } = this.state;
    let { client, startDate, endDate } = this.state.search;
    const queryStatus = status === 'all' ? null : status;
    const q = {
      page: page,
      limit: limit,
    };
    if (queryStatus) q.status = queryStatus;
    if (client) q.client = client;
    if (startDate) q.startDate = startDate;
    if (endDate) q.endDate = endDate;

    // Update URL
    this.updateUrlQuery(q);

    let response = await getDeliveryGroups(q);
    if (response.success) {
      let deliveryGroups = response.data;
      let { total, pending, approved, fundAdded, fundDeduct, completed, all } = response.meta;

      this.setState({
        deliveryGroups,
        total,
        cardMeta: [
          {
            type: 'pending',
            title: i18n.t('Pending'),
            amount: pending?.final_bid_amount,
            auctionCount: pending?.auctions_count,
          },
          {
            type: 'approved',
            title: i18n.t('approved'),
            amount: approved?.final_bid_amount,
            auctionCount: approved?.auctions_count,
          },
          {
            type: 'fundAdded',
            title: i18n.t('fundAdded'),
            amount: fundAdded?.final_bid_amount,
            auctionCount: fundAdded?.auctions_count,
          },
          {
            type: 'fundDeduct',
            title: i18n.t('fund_deduct'),
            amount: fundDeduct?.final_bid_amount,
            auctionCount: fundDeduct?.auctions_count,
          },
          {
            type: 'financeSettled',
            title: i18n.t('completed'),
            amount: completed?.final_bid_amount,
            auctionCount: completed?.auctions_count,
          },
          {
            type: 'all',
            title: i18n.t('all'),
            amount: all?.final_bid_amount,
            auctionCount: all?.auctions_count,
          },
        ].filter((card) => allowedStatuses.includes(card.type)),
        isLoading: false,
      });
    }
    this.setState({ isLoading: false });
  }
  async getAllOrganization() {
    const response = await getOrganizationList();
    let clients = response.data;
    this.setState({ clients });
  }

  getColumns = () => {
    let columns = [
      {
        name: 'Sl No',
        width: '90px',
        sortable: true,
        wrap: true,
        cell: (row, i) => i + 1,
      },
      {
        name: 'ID',
        width: '80px',
        sortable: true,
        wrap: true,
        cell: (row) => row.id,
      },
      {
        minWidth: '130px',
        name: i18n.t('project_code'),
        cell: (row) => <span className="highlight-table-value">{row.project_code}</span>,
      },
      {
        name: i18n.t('project_duration'),
        minWidth: '140px',
        cell: (row) => {
          if (!row.actual_start_date || !row.expected_end_date) return '-';

          const start = new Date(row.actual_start_date);
          const end = new Date(row.expected_end_date);

          const diffTime = end - start; // in milliseconds
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // convert to days

          return `${diffDays} days`;
        },
        wrap: true,
        center: true,
      },
      {
        minWidth: '130px',
        name: i18n.t('group_name'),
        cell: (row) => row.group_name,
      },
      {
        name: i18n.t('client'),
        cell: (row) => row.organization_name,
        wrap: true,
      },
      {
        name: i18n.t('auctions'),
        width: '90px',
        cell: (row) => row.auctions_count,
        wrap: true,
        center: true,
      },
      {
        name: i18n.t('start_date'),
        cell: (row) => row.start_date,
        wrap: true,
      },
      {
        name: i18n.t('end_date'),
        cell: (row) => row.end_date,
        wrap: true,
      },
      {
        minWidth: '130px',
        name: i18n.t('total_amount'),
        key: 'total_amount',
        cell: (row) => <span className="highlight-table-value">{row.total_amount.toFixed(3)}</span>,
        wrap: true,
        right: true,
      },
      {
        minWidth: '130px',
        name: i18n.t('client_amount'),
        cell: (row) => (
          <span className="highlight-table-value">{row.client_amount.toFixed(3)}</span>
        ),
        wrap: true,
        right: true,
      },
      {
        name: i18n.t('action'),
        wrap: true,
        minWidth: '180px',
        cell: (row) => (
          <div className="action-buttons">
            {getActionButtons(row, this.state.status, user, this)}
          </div>
        ),
      },
    ];

    if (user.role === 'C') {
      columns = columns.filter((col) => col.key !== 'total_amount');
    }

    return columns;
  };

  handleCardSelect = (cardType) => {
    this.setState(
      {
        activeTab: cardType,
        status: cardType,
        page: 1,
      },
      () => {
        this.getDeliveryGroups();
      }
    );
  };

  handleSearchChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => {
      const updatedSearch = { ...prevState.search, [name]: value };
      return { search: updatedSearch };
    });
  };

  handleSearch = () => {
    this.getDeliveryGroups();
  };

  handleClear = () => {
    const defaultSearch = {
      client: '',
      startDate: null,
      endDate: null,
      status: this.state.status,
    };

    this.setState({ search: defaultSearch, page: 1 }, () => {
      this.updateUrlQuery({ page: 1, limit: this.state.limit });
      this.getDeliveryGroups();
    });
  };

  onChangePage = (page) => {
    this.setState({ page: page }, () => {
      this.getDeliveryGroups();
    });
  };

  onChangeRowsPerPage = (limit) => {
    this.setState({ limit: limit, page: 1 }, () => {
      this.getDeliveryGroups();
    });
  };
  onAddFund = async (group) => {
    this.setState({ showAddFund: true, selectedGroup: group });
  };

  handleDownload = async (fileType) => {
    this.setState({ exportLoading: true });
    const { status, search } = this.state;
    try {
      const params = Object.fromEntries(
        Object.entries({
          client: search.client,
          startDate: search.startDate,
          endDate: search.endDate,
          status: status === 'all' ? null : DeliveryStatus[status],
          fileType,
        }).filter(([_, v]) => v !== null && v !== undefined && v !== '')
      );
      await downloadFile({
        url: `${apiUrl}v2/report/client-payment/groups`,
        params,
        token: user.token,
        fileType,
        fileName: 'Group_Auction_Delivery',
      });
    } finally {
      this.setState({ exportLoading: false });
    }
  };

  handleDownloadAuction = async (fileType) => {
    this.setState({ exportLoading: true });
    const { status, search } = this.state;
    try {
      const params = Object.fromEntries(
        Object.entries({
          client: search.client,
          startDate: search.startDate,
          endDate: search.endDate,
          status: status === 'all' ? null : DeliveryStatus[status],
          fileType,
        }).filter(([_, v]) => v !== null && v !== undefined && v !== '')
      );
      await downloadFile({
        url: `${apiUrl}v2/report/client-payment/groups/auctions`,
        params,
        token: user.token,
        fileType,
        fileName: 'Auction_Delivery',
      });
    } finally {
      this.setState({ exportLoading: false });
    }
  };
  renderListContent() {
    const { clients, deliveryGroups } = this.state;

    return (
      <>
        <div className="client-cards-container-new">
          {this.state.cardMeta.map((config) => (
            <ClientAmountCard
              key={config.type}
              {...config}
              selected={this.state.activeTab === config.type}
              onSelect={this.handleCardSelect}
            />
          ))}
        </div>

        <FilterSection
          loading={this.state.isLoading}
          onSearch={this.handleSearch}
          onClear={this.handleClear}
        >
          {/* Start Date */}
          <div className="select-wrapper floating-label-wrapper">
            <input
              id="startDate"
              type="date"
              name="startDate"
              value={this.state.search.startDate || ''}
              onChange={this.handleSearchChange}
              className="filter-base floating-input"
              placeholder=" "
            />
            <label htmlFor="startDate" className="floating-label">
              {i18n.t('start_date')}
            </label>
          </div>

          {/* End Date */}
          <div className="select-wrapper floating-label-wrapper">
            <input
              id="endDate"
              type="date"
              name="endDate"
              value={this.state.search.endDate || ''}
              onChange={this.handleSearchChange}
              className="filter-base floating-input"
              placeholder={i18n.t('end_date')}
            />
            <label htmlFor="endDate" className="floating-label">
              {i18n.t('end_date')}
            </label>
          </div>

          {/* Client Dropdown */}
          {user.role !== 'C' && (
            <Dropdown
              name="client"
              value={this.state.search.client}
              onChange={this.handleSearchChange}
              placeholder={i18n.t('client_name')}
              empty={i18n.t('select_client')}
              options={clients.map((c) => ({
                value: c.id,
                label: c.organization_name,
              }))}
            />
          )}
        </FilterSection>

        <div className="Data-Listing">
          {this.state.isLoading ? (
            <TableSkeleton columns={10} rows={10} />
          ) : deliveryGroups.length ? (
            <DataTable
              responsive={true}
              columns={this.getColumns()}
              data={deliveryGroups}
              customStyles={tableStyles}
              highlightOnHover
              pagination
              paginationServer
              paginationTotalRows={this.state.total}
              paginationPerPage={this.state.limit}
              paginationDefaultPage={this.state.page}
              paginationRowsPerPageOptions={[15, 25, 50, 100]}
              paginationComponentOptions={{
                rowsPerPageText: i18n.t('rows_per_page'),
                rangeSeparatorText: i18n.t('out'),
              }}
              onChangePage={this.onChangePage}
              onChangeRowsPerPage={this.onChangeRowsPerPage}
            />
          ) : (
            <NoData
              message={i18n.t('no_data_available')}
              actionText={i18n.t('refresh')}
              onAction={this.getDeliveryGroups.bind(this)}
            />
          )}
        </div>
      </>
    );
  }

  renderExportAction() {
    const { exportLoading } = this.state;

    return (
      <NewDropdown
        label={i18n.t('export')}
        loading={exportLoading}
        icon={Download}
        items={[
          {
            label: i18n.t('excel'),
            icon: FileSpreadsheet,
            onClick: () => this.handleDownload('excel'),
          },
          {
            label: i18n.t('excel_auctions'),
            icon: FileSpreadsheet,
            onClick: () => this.handleDownloadAuction('excel'),
          },
          {
            label: i18n.t('pdf'),
            icon: Printer,
            disabled: true,
          },
        ]}
      />
    );
  }
  render() {
    const { showAddFund, selectedGroup } = this.state;
    const isClientRole = user.role === 'C';

    const modal = (
      <AuctionAddFundModal
        show={showAddFund}
        onClose={() => {
          this.getDeliveryGroups();
          this.setState({ showAddFund: false, selectedGroup: null });
        }}
        group={selectedGroup}
      />
    );

    if (isClientRole) {
      return (
        <React.Fragment>
          <div className="cd-page">
            <div className="cd-shell">
              <p className="cd-crumb">
                <NavLink to="/client-management">{i18n.t('dashboard')}</NavLink>
                <span className="cd-crumb__current">
                  {i18n.t('auction_approval') || 'Auction Approval'}
                </span>
              </p>

              <header className="cd-hero cd-hero--compact">
                <h1 className="cd-hero__title">{i18n.t('auction_approval')}</h1>
                <p className="cd-hero__sub">
                  {i18n.t('track_auction_approval') ||
                    'Track and manage your auction approval requests.'}
                </p>
              </header>

              <div className="card">
                <div className="card-header">
                  <div className="header-action">{this.renderExportAction()}</div>
                </div>
                <div className="card-body">{this.renderListContent()}</div>
              </div>
            </div>
          </div>
          {modal}
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <HeaderBanner
          title={user.role === 'F' ? i18n.t('client_payment') : i18n.t('auction_approval')}
        />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>
                    <div className="header-action">{this.renderExportAction()}</div>
                  </div>
                  <div className="card-body">{this.renderListContent()}</div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {modal}
      </React.Fragment>
    );
  }
}

const getActionButtons = (row, status, user, ctx) => {
  const buttons = [];

  const isPM = user.role === 'PM';
  const isFinance = user.role === 'F';
  const isClient = user.role === 'C';

  const hasAuctions = row.auctions.length > 0;

  const detailPath = `/auction_approval/${row.id}?status=${ctx.state.status}`;

  // PENDING
  if (status === 'pending' && (isPM || isClient)) {
    buttons.push(<ActionButton key="process" label="process" to={detailPath} />);
  }

  // APPROVED
  if (status === 'approved') {
    if (isPM || isClient) {
      buttons.push(<ActionButton key="view" label="view" to={detailPath} />);
    } else if (isFinance) {
      buttons.push(<ActionButton key="view" label="view" to={detailPath} />);
    }
  }

  // FUND ADDED
  if (status === 'fundAdded') {
    if (isFinance) {
      buttons.push(<ActionButton key="process" label="process" to={detailPath} />);
    }
    if (isPM) {
      buttons.push(<ActionButton key="view" label="view" to={detailPath} />);
    }
  }
  // FUND DEDUCT
  if (status === 'fundDeduct') {
    if (isFinance) {
      buttons.push(<ActionButton key="process" label="process" to={detailPath} />);
    }
    if (isPM) {
      buttons.push(<ActionButton key="view" label="view" to={detailPath} />);
    }
  }
  // COMPLETED
  if (status === 'financeSettled' && hasAuctions) {
    buttons.push(<ActionButton key="view" label="view" to={detailPath} />);

    // Invoice button
    buttons.push(
      <a
        key="invoice"
        className="button1 button1-primary button1-action"
        href={`${apiUrl}auction_approval/invoice?group=${row.id}`}
        target="_blank"
        rel="noreferrer"
      >
        {i18n.t('invoice')}
      </a>
    );
  }

  return buttons;
};

const ActionButton = ({ label, icon, to, variant = 'button1-primary', onClick }) => {
  if (to) {
    return (
      <NavLink to={to} className={`button1 ${variant} button1-action`}>
        {icon} {i18n.t(label)}
      </NavLink>
    );
  }

  return (
    <button className={`button1 ${variant} button1-action`} onClick={onClick}>
      {icon} {i18n.t(label)}
    </button>
  );
};
